module.exports = "<p translate>Info.PrevLandUse</p>\n"